import { COTContextBuilder } from "./COTContextBuilder";
import {COTAnswer, COTChannel, COTMessage, COTTask} from "./COTTypes";

type SLA = {
    taskId: string,
    taskGroupId: string,
};

type PostWorkflowStart = {
    task: COTTask,
    parent: COTTask,
};

type ChangedState = COTTask;

type WorkflowStart = {
    answer: COTAnswer,
    meta: {
        parentTask: string,
        taskGroup: string,
    },
};

type Schedule = {
    [key: string]: any,
};

type SlashCommandTrigger = {
    channel: COTChannel,
    message: COTMessage,
    cmdArgs: string[],
};

type ChannelSurveyTrigger = COTAnswer | {
    messages: COTMessage[]
};

type StateSurveyTrigger = COTTask | {
    sentAnswer: COTAnswer,
};

export class COTLangSupport {
    contextBuilder: COTContextBuilder;

    constructor(baseURL: string, headers: any) {
        this.contextBuilder = new COTContextBuilder(baseURL, headers);
    }

    public async schedule(): Promise<Schedule> {
        return {};
    }

    public async slashCommandTrigger(content: string): Promise<SlashCommandTrigger> {
        if (!content.match(/^\\/)) {
            throw new Error("Command must built as: \\command arg1 arg2 ... argN. e.g., \\check machine-1");
        }
        const channel = await this.contextBuilder.channel();
        const message = await this.contextBuilder.message(content, undefined, channel._id);

        const cmdArgs = message.content.replace(/^\//, '').split(/\s+/);
        cmdArgs.shift();

        return {
            cmdArgs,
            message,
            channel,
        };
    }

    public async channelSurveyTrigger(targetSurveyId: string, includeMessages: boolean): Promise<ChannelSurveyTrigger> {
        const data = await this.contextBuilder.answer(targetSurveyId);
        if (includeMessages) {
            (data as any).messages = await this.contextBuilder.messages(targetSurveyId, data.channel);
        }
        return data;
    }

    public async stateSurveyTrigger(targetSurveyId: string): Promise<StateSurveyTrigger> {
        const task = await this.contextBuilder.task();
        const sentAnswer = await this.contextBuilder.answer(targetSurveyId);
        return { ...task, sentAnswer };
    }

    public async changedState(): Promise<ChangedState> {
        const task = await this.contextBuilder.task();
        return { ...task };
    }

    public async workflowStart(targetSurveyId: string): Promise<WorkflowStart> {
        const answer = await this.contextBuilder.answer(targetSurveyId);
        const task = await this.contextBuilder.task();
        return {
            answer,
            meta: {
                parentTask: task._id,
                taskGroup: task.taskGroup,
            },
        };
    }

    public async postWorkflowStart(): Promise<PostWorkflowStart> {
        const task = await this.contextBuilder.task();
        const parent = await this.contextBuilder.task();
        task.parent = parent._id;
        return { task, parent };
    }

    public async sla(): Promise<SLA> {
        const task = await this.contextBuilder.task();
        const taskId = task._id;
        const taskGroupId = task.taskGroup;
        return { taskId, taskGroupId }
    }
}
